import React, { useEffect, useState } from "react";

import { PermissionsSelector } from "pages/licence-checking/shared/permissions-selector";
import { LicenceCheckingSharedData } from "pages/licence-checking/shared";
import {
    ModalSize,
    NotificationToaster,
    WizardModal,
} from "components/notifications";
import { LicenceCheckingUserSearch } from "./user-search";
import { LicenceCheckingService } from "services";
import { Intent } from "@blueprintjs/core";
import PropTypes from "prop-types";

export function LicenceCheckingAddUserModal({
    isOpen = false,
    hideModal = () => {},
    onSuccess = () => {}
}) {
    const [selectedUserId, setSelectedUserId] = useState(0);
    const [isDirty, setIsDirty] = useState(false);
    const [permissions, setPermissions] = useState({});

    useEffect(() => {
        setPermissions(LicenceCheckingSharedData.getPermissions());
    }, []);

    function finishWizard() {
        let user = {
            userid: selectedUserId,
            allowPurchaseCredits: permissions[0].selected,
            allowManualChecking: permissions[1].selected,
            allowAccessGreyFleet: permissions[2].selected,
        };

        return new Promise((resolve, reject) => {
            LicenceCheckingService.addUser(user).then(
                () => {
                    NotificationToaster.show(
                        Intent.SUCCESS,
                        "User added successfully"
                    );
                    onSuccess();
                    resolve();
                },
                () => {
                    NotificationToaster.show(
                        Intent.DANGER,
                        "Error creating users"
                    );
                    reject();
                }
            );
        });
    }

    function handleCheckboxChange(event, userId) {
        if (event.target.checked) {
            setSelectedUserId(userId);
            setIsDirty(true);
        } else {
            setSelectedUserId(0);
        }
    }

    function handlePermissionChange(event, identifier) {
        event.persist();

        setPermissions((prevPermissionData) => {
            return prevPermissionData.map((permission) => {
                if (permission.id === identifier) {
                    return {
                        ...permission,
                        selected: event.target.checked,
                    };
                }

                return permission;
            });
        });
    }

    function closeModal() {
        setSelectedUserId(0);
        setPermissions(LicenceCheckingSharedData.getPermissions());
        hideModal();
    }

    return (
        <WizardModal
            isOpen={isOpen}
            title="New Licence Checking User"
            canProceed={selectedUserId > 0}
            canFinish
            onFinish={finishWizard}
            onCancel={closeModal}
            isDirty={isDirty}
            size={ModalSize.MEDIUM}
        >
            <LicenceCheckingUserSearch
                key="licence-checking-add-user-search"
                isOpen={isOpen}
                selectedUserId={selectedUserId ?? 0}
                handleCheckboxChange={handleCheckboxChange}
            />
            <PermissionsSelector
                key="licence-checking-add-user-permission-select"
                permissions={permissions}
                handlePermissionChange={handlePermissionChange}
            />
        </WizardModal>
    );
}

LicenceCheckingAddUserModal.propTypes = {
    isOpen: PropTypes.bool,
    hideModal: PropTypes.func,
    onSuccess: PropTypes.func.isRequired,
};
